import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="w-full py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20angle%20view%20of%20stadium%20green%20grass%20field%20at%20sunset%20with%20warm%20golden%20light%2C%20atmospheric%20competition%20arena%2C%20clean%20minimal%20composition%2C%20soft%20gradients%2C%20inspirational%20sports%20photography&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
          alt="一起草每日大赛参赛场景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-4">
          准备好了吗？加入今日挑战
        </h2>
        <p className="text-base text-background-200/90 mb-8 leading-relaxed">
          每天都有全新赛事等你来战。立即报名，与全国玩家一起竞技，赢取属于你的荣誉与奖励！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/caodi-jingji"
            className="w-full sm:w-auto px-8 py-4 bg-accent-500 text-background-50 rounded-lg text-base font-semibold hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
          >
            立即报名参赛
          </Link>
          <Link
            to="/article/2026-caodi-jingji-quanguo-sai"
            className="w-full sm:w-auto px-8 py-4 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-lg text-base font-semibold hover:bg-background-50/25 transition-all cursor-pointer border border-background-50/20 whitespace-nowrap"
          >
            查看最新赛事
          </Link>
        </div>
      </div>
    </section>
  );
}